import React, { useState, useEffect } from 'react';
import styles from './index.module.scss';

const AnnouncementModal = ({ isOpen, onClose }) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (isOpen) {
      setIsVisible(true);
    }
  }, [isOpen]);

  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose();
    }, 300);
  };

  const features = [
    {
      icon: '🤖',
      title: 'AI智能工艺制备',
      description: '输入您想要制备的工艺设备（如"声表面波器件"），通过智能问卷与AI多轮交互，获得详细的制备文档和个性化推荐方案。',
      highlight: '核心功能',
      color: '#3b82f6'
    },
    {
      icon: '📝',
      title: '智能问卷系统',
      description: '新增模糊处理与反馈功能，支持复杂工艺场景的智能识别和处理，提供更精准的工艺推荐。',
      highlight: '新功能',
      color: '#10b981'
    },
    {
      icon: '📤',
      title: '工艺上传与审核',
      description: '所有用户可上传新工艺方案，管理员可进行专业审核，构建完善的工艺知识库生态系统。',
      highlight: '协作功能',
      color: '#f59e0b'
    },
    {
      icon: '💾',
      title: '数据库集成',
      description: '完整的数据持久化存储，支持工艺历史记录、用户数据管理、审核流程跟踪等功能。',
      highlight: '技术升级',
      color: '#8b5cf6'
    }
  ];

  const quickStart = [
    { step: 1, text: '点击右下角AI助手按钮', icon: '💬' },
    { step: 2, text: '输入您要制备的器件名称', icon: '⌨️' },
    { step: 3, text: '填写智能问卷获得推荐', icon: '📋' },
    { step: 4, text: '查看详细制备文档', icon: '📄' }
  ];

  if (!isOpen) return null;

  return (
    <div className={`${styles.overlay} ${isVisible ? styles.visible : ''}`} onClick={handleClose}>
      <div className={`${styles.modal} ${isVisible ? styles.visible : ''}`} onClick={e => e.stopPropagation()}>
        <div className={styles.header}>
          <div className={styles.headerContent}>
            <div className={styles.logo}>
              <span className={styles.logoIcon}>🔬</span>
              <h2>北航器件制备工艺智能助手</h2>
            </div>
            <button className={styles.closeButton} onClick={handleClose}>
              ×
            </button>
          </div>
          <div className={styles.version}>
            <span className={styles.versionBadge}>v2.0</span>
            <span className={styles.versionText}>功能全面升级</span>
          </div>
        </div>

        <div className={styles.content}>
          <div className={styles.welcome}>
            <h3>🎉 欢迎使用全新升级的工艺制备智能助手</h3>
            <p>我们为您带来了更强大的AI分析能力、更完善的工艺数据库和更流畅的用户体验</p>
          </div>

          <div className={styles.quickStart}>
            <h4>🚀 快速开始</h4>
            <div className={styles.steps}>
              {quickStart.map((item, index) => (
                <div key={index} className={styles.step}>
                  <div className={styles.stepNumber}>{item.step}</div>
                  <div className={styles.stepContent}>
                    <span className={styles.stepIcon}>{item.icon}</span>
                    <span className={styles.stepText}>{item.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className={styles.contentActions}>
            <button className={styles.startButton} onClick={handleClose}>
              <span>🚀</span>
              立即开始使用
            </button>
            <div className={styles.footerInfo}>
              <span>💡 提示：您可以随时通过右上角的通知中心查看系统更新</span>
            </div>
          </div>

          <div className={styles.highlights}>
            <div className={styles.highlight}>
              <span className={styles.highlightIcon}>🎯</span>
              <div className={styles.highlightContent}>
                <strong>精准推荐</strong>
                <span>基于AI深度学习的工艺参数优化</span>
              </div>
            </div>
            <div className={styles.highlight}>
              <span className={styles.highlightIcon}>⚡</span>
              <div className={styles.highlightContent}>
                <strong>快速响应</strong>
                <span>秒级生成详细制备方案</span>
              </div>
            </div>
            <div className={styles.highlight}>
              <span className={styles.highlightIcon}>🔒</span>
              <div className={styles.highlightContent}>
                <strong>数据安全</strong>
                <span>完整的数据加密和隐私保护</span>
              </div>
            </div>
          </div>

          <div className={styles.features}>
            <h4>✨ 核心功能介绍</h4>
            <div className={styles.featureGrid}>
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className={styles.featureCard}
                  style={{ '--accent-color': feature.color }}
                >
                  <div className={styles.featureHeader}>
                    <span className={styles.featureIcon}>{feature.icon}</span>
                    <div className={styles.featureTitle}>
                      <h5>{feature.title}</h5>
                      <span className={styles.featureHighlight}>{feature.highlight}</span>
                    </div>
                  </div>
                  <p className={styles.featureDescription}>{feature.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className={styles.footer}>
          <div className={styles.footerContent} />
        </div>
      </div>
    </div>
  );
};

export default AnnouncementModal;
